import axios from 'axios';

const API_URL = "https://sridorasani-website.onrender.com";
const SESSION_KEY = 'cartSessionId';

const getSessionId = () => {
  let sessionId = localStorage.getItem(SESSION_KEY);
  if (!sessionId) {
    sessionId = typeof crypto?.randomUUID === 'function'
      ? crypto.randomUUID()
      : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem(SESSION_KEY, sessionId);
  }
  return sessionId;
};

const getCart = async () => {
  const sessionId = getSessionId();
  const response = await axios.get(`${API_URL}/api/cart/${sessionId}`);
  const cart = response.data.cart || { sessionId, items: [] };
  return cart;
};

const addToCart = async (product, quantity = 1) => {
  const sessionId = getSessionId();
  const payload = {
    sessionId,
    product: {
      _id: product._id,
      name: product.name,
      sareeId: product.sareeId || '',
      price: Number(product.price),
      image: product.image || '',
      stock: Number(product.stock || 0)
    },
    quantity
  };

  const response = await axios.post(`${API_URL}/api/cart/add`, payload);
  const cart = response.data.cart || { sessionId, items: [] };
  window.dispatchEvent(new Event('cartUpdated'));
  return cart;
};

const updateCartItem = async (productId, quantity) => {
  const sessionId = getSessionId();

  try {
    const response = await axios.patch(`${API_URL}/api/cart/update`, {
      sessionId,
      productId,
      quantity
    });

    const cart = response.data.cart || { sessionId, items: [] };
    window.dispatchEvent(new Event('cartUpdated'));
    return cart;
  } catch (error) {
    if (error.response?.status === 404 && Number(quantity) > 0) {
      const productResponse = await axios.get(`${API_URL}/api/products/${productId}`);
      const product = productResponse.data.product || productResponse.data;

      return addToCart(
        {
          _id: product._id,
          sareeId: product.sareeId || '',
          name: product.name,
          price: Number(product.price),
          stock: Number(product.stock || 0),
          image: product.images?.[0] || product.image || ''
        },
        Number(quantity)
      );
    }

    throw error;
  }
};

const removeCartItem = async (productId) => {
  const sessionId = getSessionId();
  const response = await axios.delete(`${API_URL}/api/cart/remove/${sessionId}/${productId}`);
  const cart = response.data.cart || { sessionId, items: [] };
  window.dispatchEvent(new Event('cartUpdated'));
  return cart;
};

const clearCart = async () => {
  const sessionId = getSessionId();
  const response = await axios.delete(`${API_URL}/api/cart/clear/${sessionId}`);
  const cart = response.data.cart || { sessionId, items: [] };
  window.dispatchEvent(new Event('cartUpdated'));
  return cart;
};

export { API_URL, getCart, addToCart, updateCartItem, removeCartItem, clearCart };